'use strict';

var SiteSelectorActions = function SiteSelectorActions (Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('SiteSelectorActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'SiteSelected',
    purpose: 'Detect when a site is selected in the site selector modal',
    payload: ['data']
  });

  Actions.add({
    name: 'SitePreviewSelected',
    purpose: 'Detect when a site is selected in the site selector modal',
    payload: ['data']
  });

  Actions.add({
    name: 'ShowSiteSelector',
    purpose: 'Show site selector dialog',
    payload: ['data']
  });

  Actions.add({
    name: 'HideSiteSelector',
    purpose: 'Hide site selector dialog',
    payload: ['data']
  });

  return Actions;
};

SiteSelectorActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = SiteSelectorActions;


// WEBPACK FOOTER //
// ./src/app/dash/siteSelector/SiteSelectorActions.js